import { useEffect, useRef } from 'react'

export default function GlobeTestPage() {
  const ref = useRef<HTMLDivElement>(null)

  useEffect(() => {
    if (!ref.current) return
    import('globe.gl').then((mod) => {
      try {
        const Globe = mod.default as any
        // Try different invocation patterns
        console.log('Globe type:', typeof Globe)
        console.log('Globe:', Globe)
        console.log('Globe():', typeof Globe === 'function' ? 'callable' : 'not callable')
        
        let globe: any
        if (typeof Globe === 'function') {
          try {
            globe = Globe()(ref.current!)
            console.log('Globe()() worked')
          } catch(e1) {
            console.log('Globe()() failed:', e1)
            try {
              globe = new Globe(ref.current!)
              console.log('new Globe() worked')
            } catch(e2) {
              console.log('new Globe() failed:', e2)
              try {
                globe = Globe({ animateIn: false })(ref.current!)
                console.log('Globe(opts)() worked')
              } catch(e3) {
                console.log('Globe(opts)() failed:', e3)
              }
            }
          }
        }

        if (globe) {
          globe
            .globeImageUrl('/globe/earth-blue-marble.jpg')
            .width(ref.current!.clientWidth)
            .height(400)
          console.log('Globe rendered successfully')
        }
      } catch(err) {
        console.error('Globe error:', err)
      }
    }).catch(err => console.error('Import error:', err))
  }, [])

  return (
    <div>
      <h1 style={{color:'white',padding:20}}>Globe Test Page</h1>
      <div ref={ref} style={{ width: '100%', height: 400, background: '#111' }} />
    </div>
  )
}
